<template>
  <div class="summary-errors" v-if="getBet.odds.length > 0">
    <div v-if="displayedErrorsMultiInfo.length > 0">
      <div
        v-for="(error, i) in displayedErrorsMultiInfo"
        :key="'mi_' + i"
        class="alert alert--info"
      >{{ $t(error.message) }}</div>
    </div>

    <div v-if="displayedErrors.length > 0">
      <div
        v-for="(error, i) in displayedErrors"
        :key="'err_' + i"
        class="alert alert--error"
      >
        <span>{{ error.message.includes('#') ? getErrorDesc(error.message) : $t(error.message) }}</span>
        <span v-if="error.message === 'minimumAmountNotRespected' || error.message === 'maximumAmountNotRespected'">
          — {{ getSettings.currencySymbol }} {{ error.value }}
        </span>
      </div>
    </div>

    <div v-if="displayedWarnings.length > 0">
      <div
        v-for="(warning, i) in displayedWarnings"
        :key="'warn_' + i"
        class="alert alert--warning"
      >
        <span>{{ $t(warning.message) }}</span>
        <span v-if="warning.message === 'max_winning_reached'"> — {{ getSettings.currencySymbol }} {{ warning.value }}</span>
        <span v-if="warning.message === 'max_odds_reached'"> — x {{ warning.value }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SummaryErrorsAmerican',
  computed: {
    ...mapGetters({
      getBet: 'cart/getBet',
      getSettings: 'cart/getSettings',
    }),
    displayedErrorsMultiInfo() {
      if (this.getBet.errors_multi_info && this.getBet.errors_multi_info.length > 0) {
        return this.getBet.errors_multi_info;
      }
      if (this.getBet.type === 'system') return [];
      let multiplicity = 0;
      if (this.getBet.type === 'single' || this.getBet.type === 'multiple') {
        multiplicity = +this.getBet._multiple_detail.multiplicity;
      } else if (this.getBet.type === 'integral') {
        multiplicity = +this.getBet._integral_detail.multiplicity;
      }
      let multiMinimum = 0;
      for (const odd of this.getBet.odds || []) {
        if (odd && +odd.multiplicity_min > multiMinimum) multiMinimum = +odd.multiplicity_min;
      }
      if (multiplicity < multiMinimum && multiMinimum > 0) {
        return [{ message: `multiplicity_info_${multiMinimum}` }];
      }
      return [];
    },
    displayedErrors() {
      if (this.getBet.errors && this.getBet.errors.length > 0) {
        return this.getBet.errors;
      }
      const errors = [];
      const ctx = this.getBet.context;
      const s = this.getSettings || {};
      let amount = 0;
      if (this.getBet.type === 'single' || this.getBet.type === 'multiple') {
        amount = +this.getBet._multiple_detail.amount;
      } else if (this.getBet.type === 'integral') {
        amount = +this.getBet._integral_detail.amount;
      } else if (this.getBet.type === 'system') {
        amount = +this.getBet._system_detail.amount_system;
      }
      if (ctx === 'prematch') {
        if (s.minAmount != null && +s.minAmount > 0 && amount < +s.minAmount) {
          errors.push({ message: 'minimumAmountNotRespected', value: +s.minAmount });
        }
        if (s.prematch_max_amount != null && +s.prematch_max_amount > 0 && amount > +s.prematch_max_amount) {
          errors.push({ message: 'maximumAmountNotRespected', value: +s.prematch_max_amount });
        }
      } else if (ctx === 'live' || ctx === 'mixed') {
        if (s.live_min_amount != null && +s.live_min_amount > 0 && amount < +s.live_min_amount) {
          errors.push({ message: 'minimumAmountNotRespected', value: +s.live_min_amount });
        }
        if (s.live_max_amount != null && +s.live_max_amount > 0 && amount > +s.live_max_amount) {
          errors.push({ message: 'maximumAmountNotRespected', value: +s.live_max_amount });
        }
      }
      return errors;
    },
    displayedWarnings() {
      return this.getBet.warnings || [];
    },
  },
  methods: {
    getErrorDesc(message) {
      const split = message.split('#');
      return split[0] + ' ' + this.$t(split[1]);
    },
  },
};
</script>

<style scoped>
.summary-errors {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 4px 0;
}
.alert {
  font-size: var(--font-size-xl);
  font-weight: 500;
  padding: 6px 10px;
  border-radius: 6px;
  line-height: 1.4;
  margin-bottom: 2px;
}
.alert--error {
  background: rgba(239, 68, 68, 0.1);
  color: var(--danger, #ef4444);
  border: 1px solid rgba(239, 68, 68, 0.2);
}
.alert--warning {
  background: rgba(245, 158, 11, 0.1);
  color: var(--warning, #f59e0b);
  border: 1px solid rgba(245, 158, 11, 0.2);
}
.alert--info {
  background: rgba(255, 255, 255, 0.05);
  color: var(--text-platform);
  border: 1px solid rgba(255, 255, 255, 0.1);
}
</style>
